import { fromJS } from 'immutable'
import {
  USER_EDIT_PROFILE_REQUEST,
  USER_EDIT_PROFILE_SUCCESS,
  USER_EDIT_PROFILE_FAILURE,
  USER_EDIT_PROFILE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case USER_EDIT_PROFILE_REQUEST:
      return state
        .set('isFetching', true)
    case USER_EDIT_PROFILE_SUCCESS:
      return state
        .set('employeeEditProfile', fromJS(action.payload.updatedUser))
        .set('status', 200)
        .set('message', 'Your Personal information had been saved.')
        .set('isFetching', false)
    case USER_EDIT_PROFILE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('employeeEditProfile', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case USER_EDIT_PROFILE_RESET:
      return state
        .delete('employeeEditProfile')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee/employee-edit-profile-reducer.js